import { initializeApp } from "firebase/app";
import {
  inMemoryPersistence,
  indexedDBLocalPersistence,
  initializeAuth,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyA5nMy_yX5_BA15MAbBmFaTBCpBJ6fGl5U",
  authDomain: "choir-assistant.firebaseapp.com",
  projectId: "choir-assistant",
};

const app = initializeApp(firebaseConfig);

function isThirdPartyIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

function canAccessIndexedDB(): boolean {
  try {
    if (typeof indexedDB !== "object" || indexedDB === null) return false;
    const req = indexedDB.open("__firebase_test__");
    req.onsuccess = () => {
      req.result.close();
      indexedDB.deleteDatabase("__firebase_test__");
    };
    return true;
  } catch {
    return false;
  }
}

// Safari ITP blocks IndexedDB/localStorage in cross-origin iframes.
// Missive loads integrations in an iframe, so we fall back to in-memory
// persistence when storage is unavailable.
const persistence =
  isThirdPartyIframe() && !canAccessIndexedDB()
    ? inMemoryPersistence
    : indexedDBLocalPersistence;

export const auth = initializeAuth(app, { persistence });
